module.exports = __webpack_public_path__ + "static/img/card_1_2.af004c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/es/card_1_2.png
// module id = P+dB
// module chunks = 0